export default __webpack_public_path__ + "src/assets/images/banner_four.jpg?e81e6c7a";